import { TdsButton, TdsModal, TdsModalButtons } from '@trv-tds/react'

type PhotoPreviewProps = {
  id: string
  alt?: string
  src?: string
  handleClose(): void
}

const PhotoPreviewModal = ({ alt, src, handleClose, id }: PhotoPreviewProps) => (
  <TdsModal id={id} role='dialog' dialogTitle='Photo Preview' size='large'>
    <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
      <img
        alt={alt}
        src={src}
        className="tlPrivate"
        style={{
          display: 'block',
          margin: '0 auto',
          maxWidth: '100%',
          maxHeight: '100%',
          border: 'solid 1px #979797',
          marginBottom: '5vh'
        }} />
    </div>
    <TdsModalButtons slot='footer'>
      <TdsButton variant='primary' data-dismiss='modal' onClick={handleClose}>
        Close Preview
      </TdsButton>
    </TdsModalButtons>
  </TdsModal>
)

export { PhotoPreviewModal }
